/**
 * Ryan O'Dowd
 * 2018-02-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode, safeAreaInsets}) => {
  const fabHeight = 64;
  const fabGap = 16;
  const fabBorderWidth = 4;

  return {
    headerComponentWrapper: {
      marginTop: 10,
      marginBottom: 8, // @TODO: onscroll, web overlaps the brain, mobile does not
    },
    graphic: {
      position: 'absolute',
      marginBottom: 16,
      resizeMode: 'contain',
    },
    elephantGraphic: {
      width: 48,
      height: 48,
      top: -4, // @TODO: not working with scale // @TODO: need scale though?
      left: -34, // @TODO: not working with scale // @TODO: need scale though?
    },
    brainGraphic: {
      width: 54,
      height: 86,
      top: -24, // @TODO: why is this so different from the elephant graphic? // @TODO: not working with scale // @TODO: need scale though?
      right: -34, // @TODO: not working with scale // @TODO: need scale though?
    },
    headerText: {
      fontFamily: fonts.secondaryBold,
      textAlign: 'center', // android defaults to left aligned
      paddingTop: 8,
      fontSize: 36,
      lineHeight: 36,
      color: colors.white,
    },
    betaBanner: {
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      backgroundColor: colors.alert,
      padding: 8,
    },
    betaBannerText: {
      color: colors.white,
    },
    innerContainer: (numStackedFabs) => {
      return {
        flexGrow: 1,
        paddingLeft: 0,
        paddingBottom: (numStackedFabs > 0 ? safeAreaInsets.bottom : 0) + numStackedFabs * fabHeight + (Math.max(numStackedFabs, 0) * fabGap),
      };
    },

    expandIcon: {
      justifySelf: 'center',
      alignSelf: 'center',
      padding: globalScale * 2,
      fontSize: globalScale * 14,
    },

    goalIcon: {
      paddingLeft: globalScale * 8,
    },
    activeGoalIcon: {
      color: colors.accentLight,
      opacity: 1.0,
    },
    completedGoalIcon: {
      opacity: 0.5,
    },
    completedGoalText: {
      opacity: 0.5,
    },
    activeGoalText: {
      color: colors.accentLight,
      fontFamily: fonts.primaryBold,
      opacity: 1.0,
    },
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    fab: (stackIndex) => {
      return {
        position: 'absolute',
        left: 16,
        bottom: fabGap + safeAreaInsets.bottom + (stackIndex * (fabHeight + fabGap)),
        backgroundColor: colors.primary,
        height: fabHeight,
        width: fabHeight,
        borderRadius: fabHeight / 2,
        borderWidth: fabBorderWidth,
        borderColor: colors.primaryExtraDark,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: isDarkMode ? colors.primaryExtraLight : colors.primaryExtraDark,
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.9,
        shadowRadius: 10,
        elevation: 5,
      };
    },
    fabImage: {
      position: 'absolute',
      width: fabHeight - (fabBorderWidth * 2),
      height: fabHeight - (fabBorderWidth * 2),
      borderRadius: fabHeight / 2,
      objectFit: 'contain', // @TODO: doesn't work on web...looks passable for now, though
    },
    fabText: { // @TODO: should this be part of the graphic instead?
      width: '100%',
      textAlign: 'center',
      flexDirection: 'column', // this is required for text to be centered on web
      color: colors.accent,
      fontSize: 16,
      fontFamily: fonts.secondaryBold,
      marginTop:24,
      backgroundColor: colors.primaryExtraDark,
      borderBottomRightRadius: 16,
      borderBottomLeftRadius: 16,
    },
  };
};

export default getStyles;
